import { FieldPolicyConfig } from '@field-policy';

import { FIELDS_BASE } from './fields.base';
import { FinalizeContext, FinalizeFormValues } from './types';
import { CODELIST_SYSTEMS, FORWARDER_VARIANTS, VARIANTS } from './variants';

/**
 * Everything feature-specific about resolution: which fields exist, how a context selects its
 * variant cells, and what the final lock means.
 *
 * Its own module so it can be spread into `useFormPolicy` at the call site AND composed in
 * `resolve.ts` for the form initialiser and the four node test suites. `createFieldPolicy` keys its
 * instance on `fields`, so both paths get the same policy object.
 *
 * No JSX and no `useSettings` here - this module is in the pure path.
 */
export const FINALIZE_POLICY_CONFIG: FieldPolicyConfig<FinalizeContext, typeof FIELDS_BASE, FinalizeFormValues> = {
  fields: FIELDS_BASE,
  // Country/flow first, then the forwarder overlay on top - later cells win.
  variantsFor: (ctx) => [VARIANTS[ctx.country]?.[ctx.flow], ctx.isForwarder ? FORWARDER_VARIANTS[ctx.flow] : undefined],
  lock: (rule, ctx) => (rule.amendmentLocked && ctx.isAmendment ? { ...rule, disabled: true } : rule),
  // Every field in a cell looks up against the same sources; a field or variant may still override.
  systemsFor: (ctx) => CODELIST_SYSTEMS[ctx.country]?.[ctx.flow] ?? [],
};
